// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3kiNj","rootSuccess":"CompleteLink_rootSuccess__1YqMT","rootFailure":"CompleteLink_rootFailure__cJHHV","isDisabled":"CompleteLink_isDisabled__3x3ip"};